"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const table_style_1 = require("../../components/table/table.style");
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-Accounts',
    tableCell: 'c-Accounts__TableCell',
    tableCellFaint: 'c-Accounts__TableCell--faint',
    tableCellUppercase: 'c-Accounts__TableCell--uppercase',
    tableCellGhost: 'c-Accounts__TableCell--ghost',
    tableCellRoleActions: 'c-Accounts__TableCellRole',
    changeRole: 'c-Accounts__ChangeRole'
};
exports.Style = {
    [exports.CSS.container]: {
        [`& .${table_style_1.CSS.container}`]: {
            width: '80%',
            'margin-bottom': theme_1.DefaultTheme.space(6)
        },
        [`& .${table_style_1.CSS.cell}:nth-last-of-type(2)`]: {
            overflow: 'visible'
        }
    },
    [exports.CSS.tableCellFaint]: {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [exports.CSS.tableCellUppercase]: {
        'text-transform': 'uppercase'
    },
    [`${table_style_1.CSS.row}:hover .${exports.CSS.tableCellGhost}`]: {
        visibility: 'visible'
    },
    [exports.CSS.tableCellGhost]: {
        visibility: 'hidden'
    },
    [exports.CSS.tableCellRoleActions]: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'flex-end',
        '& .mdl-button': {
            'font-size': 'inherit'
        }
    }
};
//# sourceMappingURL=accounts.style.js.map